import type {
  InterventionTemplateDetail,
  GetInterventionTemplateOptions,
} from "./intervention-template.type";

import { useGet } from "@/hooks/queries";

export const useGetInterventionTemplate = (
  id?: string | number | null,
  options?: GetInterventionTemplateOptions
) => {
  const { data, ...queryResult } = useGet<InterventionTemplateDetail>(
    "interventionTemplates",
    id,
    options
  );

  return {
    template: data,
    ...queryResult,
  };
};
